import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPlay"><Path d="M8.83051 2.38455C7.16325 1.3427 5 2.54043 5 4.50539V19.4946C5 21.4596 7.16325 22.6573 8.83051 21.6154L20.824 14.1208C22.392 13.141 22.392 10.859 20.824 9.87916L8.83051 2.38455Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlay;
